import React from 'react'
import styled from "styled-components"
import MenuIcon from '@mui/icons-material/Menu';
const Header = () => {
    return (
        <Container>
            <a>
                <img src="/images/logo.svg" alt="" />
            </a>
            <Menu>
                <a href="#">Model S</a>
                <a href="#">Model X</a>
                <a href="#">Model 3</a>
                <a href="#">Model Y</a>

            </Menu>


            <RightMenu>
                <a href="#">Shop</a>
                <a href="#">Tesla Account</a>
                <CustomMenu />
            </RightMenu>


        </Container>
    )
}

export default Header
const Container = styled.div`
min-height: 60px;
position: fixed;
display: flex;
align-items: center;
padding: 0 20px;
top: 0;
left: 0;
right: 0;
`
const Menu = styled.div`
display: flex;
justify-content: center;
margin-left: 150px;
a{
    font-weight: bold;
    text-decoration: uppercase;
    margin-left: 30px;
}
@media (max-width: 760px){
    display: none;
}
`

const RightMenu = styled.div`
margin-left: 450px;
display: flex;
a{
    font-weight: bold;
    text-decoration: uppercase;
    margin: 10px;

}
`

const CustomMenu = styled(MenuIcon)`
cursor: pointer;
margin-top: 10px;

`